import ExpertProfileEditPortfolioItemComponent from './expert-profile-edit-portfolio-item.component'

const ExpertProfileEditPortfolioItemModule = angular.module('cdbl.expert-profile-edit-portfolio-item', [

])
  .component('cdblExpertProfileEditPortfolioItem', ExpertProfileEditPortfolioItemComponent)
  .name

export default ExpertProfileEditPortfolioItemModule
